import {createMuiTheme, light, SystemColors} from '@yandex-taxi/go-web-components'

import {Theme} from './types'

const getDirectionFromConfig = () => {
  let dir = 'ltr'
  try {
    // TODO убрать ссылку на конфиг, сейчас это быстрое решение чтобы RTL завелся
    dir = window.__CORP_CLIENT.config.dir
  } catch {}
  return dir as 'ltr' | 'rtl'
}

export const createTheme = (): Theme => {
  const goTheme: Theme = createMuiTheme(light, getDirectionFromConfig())
  const fontFamily = `"Yandex Sans Text Web", ${goTheme.typography.fontFamily}`

  goTheme.palette.primary.main = goTheme.go.schemes.colors.system[SystemColors.ControlMain]
  goTheme.palette.text.primary = goTheme.go.schemes.colors.system[SystemColors.TextMain]
  goTheme.palette.text.secondary = goTheme.go.schemes.colors.system[SystemColors.TextMinor]
  goTheme.palette.action.active = goTheme.go.schemes.components.buttons.default.textColor
  goTheme.palette.background.default = goTheme.go.schemes.colors.system.BgMinor

  goTheme.typography.fontFamily = fontFamily
  goTheme.typography.body1.fontFamily = fontFamily
  goTheme.typography.body1.letterSpacing = 'normal'
  goTheme.typography.body2.fontFamily = fontFamily
  goTheme.typography.body2.fontSize = goTheme.typography.pxToRem(16)
  goTheme.typography.body2.letterSpacing = 'normal'
  goTheme.typography.button.fontFamily = fontFamily

  // включаем анимацию обратно
  if (goTheme.props?.MuiInputLabel?.disableAnimation) {
    goTheme.props.MuiInputLabel.disableAnimation = false
  }

  delete goTheme.props?.MuiInputLabel?.shrink

  return goTheme
}
